import React from 'react';
import '../nurturer-marketing/styles/marketing.css';
import LandingHero from '../nurturer-marketing/components/LandingHero';
import ProblemSection from '../nurturer-marketing/components/ProblemSection';
import SolutionSection from '../nurturer-marketing/components/SolutionSection';
import MarketingFooter from '../nurturer-marketing/components/MarketingFooter';

function LandingPage() {
  return (
    <div className="nurturer-marketing">
      <LandingHero />
      <ProblemSection />
      <SolutionSection />
      <MarketingFooter />
    </div>
  );
}

export default LandingPage;
